import React from "react";
import { Outlet } from "react-router-dom";
export default function SuperAdminIndex() {
  return <div className="p-1">
    <Outlet />
  </div>;
}
